// @flow
import * as types from '../types/buses';
import type {
  BUS_FETCH_STARTED_TYPE,
  BUS_CREATE_STARTED_TYPE,
  BUS_CREATE_SUCCEED_TYPE,
  DELETE_BUS_STARTED_TYPE,
  FETCH_SCHOOl_BUSES_STARTED_TYPE,
  FETCH_SCHOOl_BUSES_SUCCESS_TYPE,
  DELETE_BUS_SUCCESS_TYPE,
  BUS_FETCH_SUCCEED_TYPE,
  BUS_UPDATED_TYPE,
  BUS_UPDATED_LAST_CONNECTION_TYPE,
  BUS_TYPE,
  BUSES_REGISTERED_TYPE,
  BUS_REMOVED_TYPE,
  BUS_SELECTED_TYPE,
  UPDATE_BUS_STARTED_TYPE,
  UPDATE_BUS_SUCCEED_TYPE,
  BUS_FILTERS_CHANGED_TYPE,
} from '../types/buses';
import type { POINT_TYPE, ID_TYPE } from '../types/common';

import { error } from './common';

export const startFetchingBus = (id: number): BUS_FETCH_STARTED_TYPE => ({
  type: types.BUS_FETCH_STARTED,
  payload: id,
});

export const fetchBusSucceed = (bus: BUS_TYPE): BUS_FETCH_SUCCEED_TYPE => ({
  type: types.BUS_FETCH_SUCCEED,
  payload: bus,
});

export const fetchBusFailed = error(types.BUS_FETCH_FAILED);

export const updateBus = (id: number, location: POINT_TYPE): BUS_UPDATED_TYPE => ({
  type: types.BUS_UPDATED,
  payload: {
    id,
    location,
  },
});

export const updateBusLastConnection = (
  id: number,
  lastConnection: number,
  isOffline: boolean,
): BUS_UPDATED_LAST_CONNECTION_TYPE => ({
  type: types.BUS_UPDATED_LAST_CONNECTION,
  payload: {
    id,
    lastConnection,
    isOffline,
  },
});

export const registerBuses = (entities: {[number]: BUS_TYPE}): BUSES_REGISTERED_TYPE => ({
  type: types.BUSES_REGISTERED,
  payload: {
    entities,
  },
});

export const removeBus = (id: number): BUS_REMOVED_TYPE => ({
  type: types.BUS_REMOVED,
  payload: id,
});

export const busCreateStarted = (bus: BUS_TYPE): BUS_CREATE_STARTED_TYPE => ({
  type: types.BUS_CREATE_STARTED,
  payload: bus,
});

export const busCreateSuccess = (bus: BUS_TYPE): BUS_CREATE_SUCCEED_TYPE => ({
  type: types.BUS_CREATE_SUCCEED,
  payload: bus,
});

export const busCreateFailed = error(types.BUS_CREATE_FAILED);

export const busDeleteStarted = (id: number): DELETE_BUS_STARTED_TYPE => ({
  type: types.DELETE_BUS_STARTED,
  payload: id,
});

export const busDeleteSuccess = (bus: {id: number}): DELETE_BUS_SUCCESS_TYPE => ({
  type: types.DELETE_BUS_SUCCESS,
  payload: bus,
});

export const busDeleteFailed = error(types.DELETE_BUS_FAILED);

export const fetchSchoolBusesStarted = (school: number, text?: string): FETCH_SCHOOl_BUSES_STARTED_TYPE => ({
  type: types.FETCH_SCHOOl_BUSES_STARTED,
  payload: {
    school,
    text,
  },
});

export const fetchSchoolBusesSuccess = (
  entities: {[number]: BUS_TYPE},
  order: Array<number>,
): FETCH_SCHOOl_BUSES_SUCCESS_TYPE => ({
  type: types.FETCH_SCHOOl_BUSES_SUCCESS,
  payload: {
    entities,
    order,
  },
});

export const selectBus = (
  payload: ID_TYPE,
): BUS_SELECTED_TYPE => ({
  type: types.BUS_SELECTED,
  payload,
});

export const updateBusStarted = (changes: Object): UPDATE_BUS_STARTED_TYPE => ({
  type: types.UPDATE_BUS_STARTED,
  payload: changes,
});

export const updateBusSucceed = (bus: BUS_TYPE): UPDATE_BUS_SUCCEED_TYPE => ({
  type: types.UPDATE_BUS_SUCCEED,
  payload: bus,
});

export const updateBusFailed = error(types.UPDATE_BUS_FAILED);

export const fetchSchoolBusesFailed = error(types.FETCH_SCHOOl_BUSES_FAILED);

export const changeBusFilters = (filter: string): BUS_FILTERS_CHANGED_TYPE => ({
  type: types.BUS_FILTERS_CHANGED,
  payload: filter,
});



// WEBPACK FOOTER //
// ./src/scripts/actions/buses.js